import { render, staticRenderFns } from "./OpenClass.vue?vue&type=template&id=433f2fe2&scoped=true&"
import script from "./OpenClass.vue?vue&type=script&lang=js&"
export * from "./OpenClass.vue?vue&type=script&lang=js&"
import style0 from "./OpenClass.vue?vue&type=style&index=0&id=433f2fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f2fe2",
  null
  
)

export default component.exports